/**
 * Gearby homepage: intro → landing overlay; [data-landing-dismiss] on Home / Showroom / Account / logo dismisses overlay and navigates when href is another page.
 */
(function () {
  const root = document.querySelector('[data-gearby-intro-root]');
  if (!root) return;

  const main = root.querySelector('[data-gearby-home-main]');
  const landing = root.querySelector('[data-gearby-landing]');
  const landingBgBase = landing?.querySelector('[data-landing-bg-base]');
  const landingBgFade = landing?.querySelector('[data-landing-bg-fade]');
  /* getAttribute — dataset.landingBg02 is unreliable for data-landing-bg-02 (numeric suffix) */
  const landingSequence = [
    landing?.getAttribute('data-landing-bg-02'),
    landing?.getAttribute('data-landing-bg-03'),
  ].filter(Boolean);
  let landingLoopTimeout;
  let landingFadeTimeout;
  let landingStep = 0;
  const LANDING_HOLD_MS = 3000;
  const LANDING_FADE_MS = 420;

  if (root.dataset.introPhase === 'done') {
    document.documentElement.classList.remove('gearby-intro-lock');
    if (main) main.removeAttribute('inert');
    return;
  }

  const setPhase = (phase) => {
    root.dataset.introPhase = phase;
    if (phase === 'done') {
      document.documentElement.classList.remove('gearby-intro-lock');
    }
  };

  const cssBg = (url) => `url("${String(url).replace(/"/g, '\\"')}")`;

  const preloadLandingImages = () => {
    landingSequence.forEach((url) => {
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
    });
  };

  const goPhase2 = () => setPhase('2');
  const stopLandingLoop = () => {
    window.clearTimeout(landingLoopTimeout);
    window.clearTimeout(landingFadeTimeout);
    if (landingBgFade) {
      landingBgFade.classList.remove('is-visible');
      landingBgFade.style.backgroundImage = 'none';
    }
    if (landingBgBase) {
      landingBgBase.style.backgroundImage = 'none';
    }
    landingStep = 0;
  };

  const startLandingLoop = () => {
    stopLandingLoop();
    if (!landingBgBase || !landingBgFade || landingSequence.length === 0) return;

    preloadLandingImages();

    const runStep = () => {
      const imageUrl = landingSequence[landingStep];
      landingBgFade.style.backgroundImage = cssBg(imageUrl);
      landingBgFade.classList.add('is-visible');

      landingFadeTimeout = window.setTimeout(() => {
        landingBgBase.style.backgroundImage = cssBg(imageUrl);
        landingBgFade.classList.remove('is-visible');
      }, LANDING_FADE_MS);

      landingStep = (landingStep + 1) % landingSequence.length;
      landingLoopTimeout = window.setTimeout(runStep, LANDING_HOLD_MS);
    };

    runStep();
  };

  const goPhase3 = () => {
    setPhase('3');
    startLandingLoop();
  };

  const finish = () => {
    setPhase('done');
    root.classList.add('gearby-intro-root--done');
    if (landing) {
      landing.classList.add('gearby-landing--visible');
      landing.removeAttribute('aria-hidden');
      if (main) main.setAttribute('inert', '');
    } else if (main) {
      main.removeAttribute('inert');
    }
    window.dispatchEvent(new CustomEvent('gearby:landing-visible'));
  };

  function dismissLandingOverlay() {
    if (landing) {
      landing.classList.remove('gearby-landing--visible');
      landing.setAttribute('aria-hidden', 'true');
    }
    stopLandingLoop();
    if (main) main.removeAttribute('inert');
    window.scrollTo(0, 0);
    window.dispatchEvent(new CustomEvent('gearby:landing-dismissed'));
  }

  /**
   * Landing links: do not call preventDefault() when the href goes to another document — let the
   * browser navigate (avoids broken assign()/pathname checks with preview params, locales, etc.).
   * Same-document (e.g. Home on homepage): preventDefault and only dismiss the overlay.
   */
  root.addEventListener('click', (e) => {
    const dismiss = e.target.closest('[data-landing-dismiss]');
    if (!dismiss) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    const dismissHref = dismiss.getAttribute('href');
    if (!dismissHref || dismissHref === '#') {
      e.preventDefault();
      dismissLandingOverlay();
      return;
    }

    let targetUrl;
    let hereUrl;
    try {
      targetUrl = new URL(dismissHref, window.location.href);
      hereUrl = new URL(window.location.href);
    } catch (_) {
      e.preventDefault();
      dismissLandingOverlay();
      return;
    }

    const samePath =
      targetUrl.origin === hereUrl.origin && targetUrl.pathname === hereUrl.pathname;

    if (!samePath) {
      dismissLandingOverlay();
      return;
    }

    e.preventDefault();
    dismissLandingOverlay();
  });

  document.documentElement.classList.add('gearby-intro-lock');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', goPhase2, { once: true });
  } else {
    goPhase2();
  }

  window.addEventListener(
    'load',
    () => {
      window.setTimeout(goPhase3, 780);
      window.setTimeout(finish, 1040);
    },
    { once: true }
  );
})();
